/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 7/10/2020
 */

import DbBaseObject from "@shared/DbBaseObject.js";
import {Type} from "class-transformer";
import AvailabilitySettings from "@/core/js/model/scheduler/AvailabilitySettings";


export class SchedulerSettings extends DbBaseObject{

	@Type(() => AvailabilitySettings)
	availabilitySettings: AvailabilitySettings = new AvailabilitySettings();
	eventTypeUserId: string = "";
	timeZone: string = ""
	setupStep: number = 0;
	isSetupCompleted: boolean = false;


	constructor() {
		super();
	}

	schedulerRootUrl(){
		let domain = process.env.VUE_APP_DOMAIN || ""

		return domain + "/" + this.eventTypeUserId
	}




}
